import { useEffect, type ReactNode } from 'react'
import { Toaster } from 'sonner'
import { useAuthStore } from '@/stores/auth-store'
import { useRuntimeConfigStore } from '@/stores/runtime-config-store'

export function AppProviders({ children }: { children: ReactNode }) {
  useEffect(() => {
    void useRuntimeConfigStore.getState().bootstrap()
    void useAuthStore.getState().bootstrap()
    const expired = () => useAuthStore.getState().expireSession()
    window.addEventListener('video-transcript:session-expired', expired)
    return () => window.removeEventListener('video-transcript:session-expired', expired)
  }, [])

  return (
    <>
      {children}
      <Toaster richColors position="top-center" />
    </>
  )
}
